import { WebAudioMedia } from './WebAudioMedia';
import { WebAudioInstance } from './WebAudioInstance';
import { WebAudioNodes } from './WebAudioNodes';
import { WebAudioContext } from './WebAudioContext';
import { WebAudioUtils } from './WebAudioUtils';

/**
 * Classes supporting non-WebAudio based browsers.
 * @namespace webaudio
 */
export default {
    WebAudioMedia,
    WebAudioInstance,
    WebAudioNodes,
    WebAudioContext,
    WebAudioUtils
};
